var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.7727 0 0 10.7727 0 24C0 37.2273 10.7727 48 24 48C37.2273 48 48 37.2273 48 24C48 10.6363 37.2273 0 24 0ZM34.0909 19.9091L22.9091 31.0909C22.0909 31.9091 20.5909 31.9091 19.7727 31.0909L13.9091 25.2273C13.0909 24.4091 13.0909 22.9091 13.9091 22.0909C14.7273 21.2727 16.2273 21.2727 17.0455 22.0909L21.4091 26.4546L31.0909 16.7727C31.9091 15.9545 33.4091 15.9545 34.2273 16.7727C34.9091 17.7273 34.9091 19.0909 34.0909 19.9091Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.ce4ab3f2aa03b3720a00505393b6b4c4.svg";
export { ForwardRef as ReactComponent };